import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Signup.css";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";
import { Api } from "../api";
import { AxiosError } from "axios";

function Signup() {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    
    try {
      const response = await Api.post("auth/register", formData);
      
      if (response.status === 201) {
        const message = response.data?.message || 'Account created successfully! Please check your email to verify your account.';
        
        // Show success message briefly before redirecting
        setSuccess(message);
        
        // Store email for verification page
        localStorage.setItem('pendingVerificationEmail', formData.email);
        
        // Redirect to verification page after showing success
        setTimeout(() => {
          navigate(ROUTES.VerifyEmail(), { 
            state: { 
              email: formData.email,
              message: 'Please check your email for a verification code.'
            }
          });
        }, 1500);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data?.message;
        
        // Check if this is a "check your email" type message (account might exist)
        if (errorMessage && errorMessage.toLowerCase().includes('check your email')) {
          setSuccess(errorMessage);
          localStorage.setItem('pendingVerificationEmail', formData.email);
          
          // Redirect after showing message
          setTimeout(() => {
            navigate(ROUTES.VerifyEmail(), { 
              state: { email: formData.email }
            });
          }, 1500);
        } else {
          // Show actual error to user
          setError(errorMessage || 'Signup failed. Please try again.');
        }
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    }
  };

  return (
    <form className="signup-form" onSubmit={handleSubmit}>
      <div className="signup-form-header">
        <h2 className="signup-form-title">Sign Up</h2>
      </div>
      <label htmlFor="first-name" className="signup-form-label">
        First Name
      </label>
      <input
        id="first-name"
        type="text"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        className="signup-form-input"
      />
      <label htmlFor="last-name" className="signup-form-label">
        Last Name
      </label>
      <input
        id="last-name"
        type="text"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        className="signup-form-input"
      />
      <label htmlFor="email" className="signup-form-label">
        Email
      </label>
      <input
        id="email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        className="signup-form-input"
      />
      <label htmlFor="password" className="signup-form-label">
        Password
      </label>
      <input
        id="password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        className="signup-form-input"
      />
      {error && <p className="signup-form-error">{error}</p>}
      {success && <p className="signup-form-success">{success}</p>}
      <button type="submit" className="signup-form-button">
        Sign Up
      </button>
      <div className="signup-form-footer">
        <div></div>
        <NavLink to="/auth/login" className="signup-form-link right-link">
          Login
        </NavLink>
      </div>
    </form>
  );
}

export default Signup;
